import {
  all, call, put, takeLatest,
} from 'redux-saga/effects';
import * as constants from 'redux/constants/shipping.constants';
import { getSingleQuote, getCartQuote, getTrackingGuide } from 'services/shipping.services';

export function* shippingGetSingleQuote(action) {
  try {
    if (action.value && action.productId) {
      const data = yield call(getSingleQuote, action.value, action.productId);
      yield put({ type: constants.SHIPPING_GET_SINGLE_QUOTE_SUCCEEDED, data: { ...data, zipCode: action.value } });
    }
  } catch (error) {
    yield put({ type: constants.SHIPPING_GET_SINGLE_QUOTE_FAILED, error });
  }
}

export function* shippingGetCartQuote(action) {
  try {
    if (action.value && action.items.length > 0) {
      const data = yield call(getCartQuote, action.value, action.items);
      yield put({ type: constants.SHIPPING_GET_CART_QUOTE_SUCCEEDED, data: { ...data, zipCode: action.value } });
    }
  } catch (error) {
    yield put({ type: constants.SHIPPING_GET_CART_QUOTE_FAILED, error });
  }
}

export function* shippingGetTrackingGuide(action) {
  try {
    const data = yield call(getTrackingGuide, action.value);
    yield put({ type: constants.SHIPPING_GET_TRACKING_GUIDE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.SHIPPING_GET_TRACKING_GUIDE_FAILED, error });
  }
}

export function* watchShipping() {
  yield all([
    takeLatest(constants.SHIPPING_GET_SINGLE_QUOTE_REQUESTED, shippingGetSingleQuote),
    takeLatest(constants.SHIPPING_GET_CART_QUOTE_REQUESTED, shippingGetCartQuote),
    takeLatest(constants.SHIPPING_GET_TRACKING_GUIDE_REQUESTED, shippingGetTrackingGuide),
  ]);
}
